/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */
import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  Badge,
  Card, CardBody, Col, Container, DropdownItem, DropdownMenu, DropdownToggle, Row, Table, UncontrolledDropdown,
} from 'reactstrap';
import { RTLProps } from '@/shared/prop-types/ReducerProps';
import { useQuery } from 'react-query';
import axios from 'axios';
import { useCookies } from 'react-cookie';
import { useHistory, useParams } from 'react-router';
import ChevronDownIcon from 'mdi-react/ChevronDownIcon';

const Bids = ({ rtl }) => {
  const { t } = useTranslation('common');
  const [cookies, setCookie] = useCookies(['tranAuthToken']);


  const { id } = useParams();

  const
    {
      data,
      isLoading,
      isFetching,
      isError,
    } = useQuery('todos', () => axios.get(`https://orca-app-5i5qx.ondigitalocean.app/api/admin/bids/${id}`, {
      headers: {
        Authorization: `Bearer ${cookies.tranAuthToken}`,
      },
    }));
  if (data && !isLoading && !isFetching && !isError) {
    console.log('all Bids', data.data); 
  }



  return (
    <Container className="dashboard">
      <Row>
        <Col md={12}>
          <h3 className="page-title">All Bids</h3>
        </Col>
      </Row>
      <Row>
        <Col md={12} lg={12}>
          <Card>
            <CardBody>
              <div className="card__title">
                <h5 className="bold-text">All Bids Table</h5>
              </div>
              <Table responsive hover className="table--bordered">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Advance</th>
                    <th>Against Bill</th>
                    <th>Remarks</th>
                    <th>Status</th>
                    <th>Time</th>
                    <th>Transporter</th>
                    <th>Transporter Email</th>

                  </tr>
                </thead>
                <tbody>
                  {isFetching && <tr><td>Loading...</td></tr>}
                  {!isLoading && !isFetching && !isError && data && data.data && data.data && data.data.map((item, index) => (
                    <tr key={item._id}>
                      <td>{item._id}</td>
                      <td>{item.advance}</td>
                      <td>{item.againstBill}</td>
                      <td>{item.remarks}</td>
                      <td><Badge color="success">{item.status}</Badge></td>
                      <td>{new Date(item.timestamp).toLocaleDateString()} {new Date(item.timestamp).toLocaleTimeString()}</td>
                      <td>{item.transporter}</td>
                      <td>{item.transporterEmail}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

Bids.propTypes = {
  rtl: RTLProps.isRequired,
};

export default connect(state => ({
  rtl: state.rtl,
}))(Bids);
